
import { useObserver } from 'mobx-react-lite';
import React, { ReactElement, useContext, useEffect, useMemo, useState } from 'react';
import { AppContext } from '../../../state/app.state';
import { isMobile } from '../../../utils/app.helper';
import { Modal } from '../../overlay';
import ObjectViewImageGallery from '../../views/ObjectView/Desktop/ObjectViewImageGallery/ObjectViewImageGallery';
import { CurrentImageT } from '../../views/ObjectView/Desktop/OV-subcomponents';
import { getImageDimensionsOf } from '../SunStudyTimeline/SunStudyModal';


type ImageModalProps={
};
const ImageModal: React.FC<ImageModalProps> = (): ReactElement => {
    const { presentationState } = useContext(AppContext);

    useEffect(() => {
        presentationState?.setWidth();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const [ratio, setRatio] = useState(1.2);

    useEffect(() => {
        presentationState?.showImageGalleryModal?.files[0].url?.original && getImageDimensionsOf(presentationState?.showImageGalleryModal?.files[0].url?.original).then(result => {
            setRatio(result.width / result.height);
        });
    }, [presentationState?.showImageGalleryModal?.files]);

    const [currentImages, setCurrentImages] = useState<CurrentImageT[] | undefined>();
    const [imageIndex, setImageIndex] = useState(0);
    const [prevImageIndex, setPrevImageIndex] = useState(-1);

    const currentImage = currentImages?.find((f, i) => i === imageIndex);


    useEffect(() => {
        setImageIndex(0);
        setPrevImageIndex(-1);

        const imageCollectionImages = presentationState?.showImageGalleryModal
            ?.files?.slice().sort((a, b) => {
                return a.sortOrder - b.sortOrder;
            })
            ?.filter(f => f.type === 'image')
            .map(f => ({ image: f, subtype: 'image' }));


        setCurrentImages(imageCollectionImages);


    }, [presentationState?.showImageGalleryModal?.files]);

    return useObserver(() => (
        <Modal
            showModal={!!presentationState?.showImageGalleryModal}
            onBackdropClick={(): void => {
                presentationState?.setShowImageGalleryModal(undefined);
            }}
            modalPaperStyle={{
                maxHeight: 'unset',
                margin: 0,
                backgroundColor: '#f1f1f1',
                maxWidth: 'unset',
                height:  isMobile() ? 'auto' : 'calc(100% - 2rem)',
                width: isMobile() ? '100%' : ((presentationState?.modalWidth && `calc(${presentationState?.modalWidth * (ratio ? (ratio) : 1)}px)`) || '80vh'),
                borderRadius: '2rem',
                overflow:'hidden' }}>
            <ObjectViewImageGallery
                currentImage={currentImage}
                currentImages={currentImages}
                setImageIndex={setImageIndex}
                imageIndex={imageIndex}
                isModal={true}
                showImages={true}
                prevImageIndex={prevImageIndex}
                setPrevImageIndex={setPrevImageIndex}
                selectedObject={undefined}
            />
        </Modal>));
};


export default ImageModal;